export default function ClosingCta() {
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20painterly%20background%20of%20soft%20amber%20and%20deep%20crimson%20gradient%20waves%20with%20delicate%20golden%20floral%20line%20motifs%2C%20glowing%20bokeh%20particles%2C%20romantic%20artistic%20texture%2C%20dark%20vignette%20edges%20for%20readable%20light%20text%20overlay&width=1920&height=800&seq=plxdz-closing-cta&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/55 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
            找到属于你的那一款衍生内容
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200">
            无论你想读完整主线、只看情感片段，还是顺着标签找同款方向，都可以从下面两个入口继续浏览。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="#novel"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-book-open-line"></i>
              浏览小说专区
            </a>
            <a
              href="#similar"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-secondary-950 text-sm md:text-base font-medium whitespace-nowrap hover:bg-accent-400 transition-colors"
            >
              <i className="ri-compass-3-line"></i>
              按标签找同款
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}